var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"loading":_vm.loading,"title":_vm.title,"outlined":_vm.outlined},on:{"click":function($event){return _vm.submit()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }